// R6-2: the per-team completed-game score (points, plus an optional shootout
// tally in parentheses) is rendered identically on the neutral matchday
// scoreline (DailySchedule) and the home last-game card (LeagueDashboard). This
// is the one verbatim-shared fragment of those "completed game" rows — the rows
// otherwise diverge on purpose (dense list row vs hero card, and gameLog's
// my-perspective result feed), so only the score atom is factored out here to
// keep the shootout presentation in one place.
export const TeamScoreValue = ({
	pts,
	sPts,
	shootoutClassName = "fw-normal",
}: {
	pts?: number;
	sPts?: number;
	shootoutClassName?: string;
}) => (
	<>
		{pts}
		{sPts !== undefined ? (
			<span className={shootoutClassName}> ({sPts})</span>
		) : null}
	</>
);
